import MUIAlert, { AlertProps } from '@mui/material/Alert';
import MUIAlertTitle, { AlertTitleProps } from '@mui/material/AlertTitle';
import React from 'react';

export const MuiAlert = React.forwardRef<HTMLDivElement, AlertProps>((props, ref) => {
	return <MUIAlert ref={ref} {...props} sx={{ borderRadius: theme => `${theme.shape['radius-md']}px`, ...(props.sx ?? {}) }} />;
});

export const MuiAlertTitle = (props: AlertTitleProps) => {
	return <MUIAlertTitle {...props}>{props.children}</MUIAlertTitle>;
};
